import { render, staticRenderFns } from "./CustomerUserTypeSettings.vue?vue&type=template&id=73c663d5&scoped=true&"
import script from "./CustomerUserTypeSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerUserTypeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c663d5",
  null
  
)

export default component.exports